import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class SetorPadraoService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private tokenService: TokenService, private http: HttpClient) { }

  getListagemSetores(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/setor/list`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownSetores(params): Observable<any> {
    this.httpOptions.params = params;
    return this.http.get(`${this.apiUrl}api/setor/listagem/dropdown`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getById(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/setor/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  create(setor): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/setor`, setor, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  update(setor): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/setor`, setor, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownSetoresB2c(filtros): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/b2c/dropdown-setores`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
